<template>
  <div class="container-fluid" id="contracts" role="tabpanel" aria-labelledby="contracts-tab">

    <!-- NUEVO MODULO DE CONTRATOS -->
    <div id="new-contracts">
      <div class="vx-row">
        <!-- BANNER -->
        <div class="vx-col w-full mb-4">
          <vx-card>
            <div class="flex flex-wrap justify-between">
              <h1 class="bold m-0">Contratos del <span class="success">crédito</span>.</h1>
              <!-- GENERAR CONTRATOS -->
              <div class="flex gap-4">
                <vs-button size="sm" color="success" @click="changeFirstPaymentDateHandler()">
                  Cambiar fecha de pago
                </vs-button>
                <vs-button v-if="project.status >= 4 && hasContractsGenerated" class="mr-2 text-sm" type="border"
                  size="small" :disabled="!(project.status >= 4 && project.approved_date != null)"
                  @click="verDialog(2)">
                  GENERAR CONTRATOS FINIQUITO
                </vs-button>
                <vs-button v-if="project.status === 4 || project.status === 5 || project.status === 6 || project.status === 7 || project.status === 8" class="text-sm"
                  size="small" :disabled="!(project.status >= 4 && project.approved_date != null)"
                  @click="verDialog(1)">
                  GENERAR CONTRATOS ANTICIPO
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>

        <!-- DETALLE DE CONTRATOS -->
        <div class="vx-col sm:w-full md:w-3/4">
          <div class="vx-row">
            <!-- CONTRATOS -->
            <div class="vx-col w-full mb-4">
              <vx-card>
                <p class="success bold">
                  CONTRATOS
                </p>
                <div class="vx-row">
                  <div v-if="contract_groups !== null && contract_groups.length > 0 && project.contracts.length > 0"
                    class="vx-col w-full">
                    <vx-card v-for="group in contract_groups" class="mb-4">
                      <h3 class="bold">
                        {{ group.group.name }}
                      </h3>
                      <div class="vx-row">
                        <div class="vx-col w-1/2">
                          <p>
                            <span class="bold">Tipo de firma:</span> {{ translateSigningTypeEngine(group.signing_type)
                            }}
                          </p>
                        </div>
                        <div class="vx-col w-1/2">
                          <div class="flex justify-content-end">
                            <vs-button title="Cancelar grupo" radius class="ml-1" color="danger" type="filled"
                              icon-pack="feather" icon="icon-x-circle"
                              v-if="group.status == 'generated' || group.status == 'sent' || (group.status == 'signed')"
                              @click="cancelarGrupo(group)" />

                            <vs-button title="Enviar a Firma" radius class="ml-1" color="primary" type="filled"
                              icon-pack="feather" icon="icon-send" v-if="group.status == 'generated'"
                              @click="verSentDialog(group)" />

                            <vs-button title="Reenviar Correo" radius class="ml-1" color="primary" type="filled"
                              icon-pack="feather" icon="icon-mail" v-if="group.status == 'sent'"
                              @click="_resendContracts(group)" />

                            <vs-button title="Descargar" radius class="ml-1" :color="'#2D2D2D'" type="filled"
                              icon-pack="feather" icon="icon-download" @click="verDownloadDialog(group)" />

                            <vs-button title="Ver FAD info" radius class="ml-1" color="warning" type="filled"
                              icon-pack="feather" icon="icon-eye" v-if="group.signing_type == 3"
                              @click="verFADDialog(group)" />

                            <vs-button title="Marcar como Firmado" radius class="ml-1" color="warning" type="filled"
                              icon-pack="feather" icon="icon-edit-3" @click="manualSigned(group)"
                              v-if="group.signing_type == 1 && group.status == 'sent'" />

                            <vs-button title="Verificar" radius class="ml-1" color="success" type="filled"
                              icon-pack="feather" icon="icon-check-circle" @click="requestVerification(group)"
                              v-if="group.status === 'signed'" />
                          </div>
                        </div>
                      </div>
                      <vs-divider></vs-divider>
                      <div v-if="showed.includes(group.group.id)" class="vx-row">
                        <div class="vx-col w-1/4">
                          <h6 class="bold">Documento(s)</h6>
                          <div
                            v-for="contract in project.contracts.filter(item => { return item.contract_group_id === group.group.id })"
                            v-bind:key="contract.id">
                            <template v-if="needsToShowDocument(group.group.id, contract.type.name)">
                              {{ contract.type.name }}
                            </template>
                          </div>
                        </div>
                        <div class="vx-col w-1/4">
                          <h6 class="bold">Estado</h6>
                          <div class="mb-4">
                            <span class="label" v-bind:class="{
                              'label-status-1': (group.status == 'signed' || group.status == 'verified'),
                              'label-status-10': (group.status == 'generated' || group.status == 'sent'),
                              'label-status-9': (group.status == 'canceled')
                            }">{{ translateContractStatus(group.status) }}</span>
                          </div>
                          <h6 class="bold">Versión</h6>
                          <div class="mb-4">
                            {{ getContractToRender(group.group.id).type.version }}
                          </div>
                          <h6 class="bold">Fecha de creación</h6>
                          <div class="mb-4">
                            {{ humanizedCompactDate(getContractToRender(group.group.id).created_at) }}
                          </div>
                        </div>
                        <div class="vx-col w-1/3">
                          <h6 class="bold">Firmantes</h6>
                          <div
                            v-if="getContractToRender(group.group.id).signing_type == 2 && getContractToRender(group.group.id).mifiel_object != null">
                            <ul>
                              <li :key="index"
                                v-for="(signer, index) in buildMiFielLinks(getContractToRender(group.group.id).mifiel_object)"
                                class="flex">
                                <div class="mr-1 contract-status"
                                  :class="signer.signed ? 'bg-success' : 'bg-grey-light'"></div>
                                <a :href="'mailto:' + signer.email"> {{ signer.email }}</a>
                              </li>
                            </ul>
                          </div>
                          <div v-else>
                            <ul v-for="signatory in getContractToRender(group.group.id).signatories_json">
                              <li><a :href="'mailto:' + signatory.email"> {{ signatory.email }}</a></li>
                            </ul>
                          </div>
                          <h6 class="bold mt-3">Links de firma</h6>
                          <vs-button @click.stop="showFADLinks(getContractToRender(group.group.id))" radius
                            color="warning" type="filled" icon="insert_link"></vs-button>
                        </div>
                        <div class="vx-col w-1/4">
                        </div>
                      </div>
                      <div class="mt-4" v-if="group.group.id == 1">
                        <h3 class="bold">
                          Pagaré
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div v-if="contract.type.type == 7"
                              v-for="contract in project.contracts.filter(item => { return item.contract_group_id === group.group.id })"
                              v-bind:key="contract.id">
                              <p>
                                <span class="bold">Tipo de firma:</span> {{
                                  translateSigningTypeEngine(group.signing_type) }}
                              </p>
                              <vs-divider></vs-divider>
                              <div class="vx-row">
                                <div class="vx-col w-1/4">
                                  <h6 class="bold">Documento(s)</h6>
                                  <div class="mb-4">
                                    {{ contract.type.name }}
                                  </div>
                                </div>
                                <div class="vx-col w-1/4">
                                  <h6 class="bold">Estado</h6>
                                  <span class="label" v-bind:class="{
                                    'label-status-1': (contract.status == 'signed' || contract.status == 'verified'),
                                    'label-status-10': (contract.status == 'generated' || contract.status == 'sent'),
                                    'label-status-9': (contract.status == 'canceled')
                                  }">{{ translateContractStatus(contract.status) }}</span>
                                  <h6 class="bold mt-4">Versión</h6>
                                  <div class="mb-4">
                                    {{ contract.type.version }}
                                  </div>
                                  <h6 class="bold">Fecha de creación</h6>
                                  <div class="mb-4">
                                    {{ humanizedCompactDate(contract.created_at) }}
                                  </div>
                                </div>
                                <div class="vx-col w-1/3">
                                  <h6 class="bold">Firmantes</h6>
                                  <div v-if="contract.signing_type == 2 && contract.mifiel_object != null">
                                    <ul>
                                      <li :key="index"
                                        v-for="(signer, index) in buildMiFielLinks(contract.mifiel_object)"
                                        class="flex">
                                        <div class="mr-1 contract-status"
                                          :class="signer.signed ? 'bg-success' : 'bg-grey-light'"></div>
                                        <a :href="'mailto:' + signer.email"> {{ signer.email }}</a>
                                      </li>
                                    </ul>
                                  </div>
                                  <div v-else>
                                    <ul v-for="signatory in contract.signatories_json">
                                      <li><a :href="'mailto:' + signatory.email"> {{ signatory.email }}</a></li>
                                    </ul>
                                  </div>
                                  <h6 class="bold mt-3">Links de firma</h6>
                                  <vs-button @click.stop="showFADLinks(contract)" radius color="warning" type="filled"
                                    icon="insert_link"></vs-button>
                                </div>
                                <div class="vx-col w-1/8">
                                  <vs-button title="Reenviar Pagaré" radius class="ml-1" color="primary" type="filled"
                                    icon-pack="feather" icon="icon-send"
                                    v-if="contract.type.name == 'Pagaré' && contract.fad_requisition == null && contract.signing_type == 3 && contract.status == 'sent'"
                                    @click="verSentDialog(group, true)" />
                                  <vs-button title="Reenviar Pagaré" radius class="ml-1" color="primary" type="filled"
                                    icon-pack="feather" icon="icon-send"
                                    v-else-if="contract.type.name == 'Pagaré' && contract.signing_type == 2 && (contract.status == 'generated')"
                                    @click="verSentDialog(group, true)" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                  <div v-else class="vx-col w-full not-generated">
                    <h4>
                      No se han generado aún contratos para este proyecto.
                    </h4>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>

        <!-- HERRAMIENTAS -->
        <div class="vx-col sm:w-full md:w-1/4">
          <!-- DETALLES DE FIRMATES Y FECHA DE CORTE -->
          <vx-card class="mb-4">
            <p class="success bold">
              DETALLES
            </p>
            <div class="vx-row">
              <!-- FECHA DE PRIMER PAGO -->
              <!-- <div class="vx-col w-full">
                <div class="flex">
                  <md-field>
                    <label>Fecha de primer pago</label>
                    <md-input type="date" class="form-control" v-model="project.finance.first_payment_date" />
                  </md-field>
                  <vs-button
                    color="success"
                    class="mt-3 ml-3"
                    :disabled="project.status > 6"
                    @click="requestUpdateContractData()"
                    icon-pack="feather"
                    icon="icon-save">
                  </vs-button>
                </div>
              </div> -->
              <div v-if="relatedProjects.running.length != 0" class="vx-col w-full">
                <vs-divider>PROYECTOS RELACIONADOS</vs-divider>
                <!-- v-if="item.id != project.id" -->
                <vx-card v-for="(item, index) in relatedProjects.running">
                  <ul>
                    <li class="bold">{{ item.id }} - {{ item.alias }}</li>
                    <li>Estado: {{ item.status }} - {{ projectStatusName(item.status) }}</li>
                    <li>Día de corte: {{ getDayFromDate(item.cut_day) }}</li>
                  </ul>
                </vx-card>
              </div>
              <div class="vx-col w-full">
                <vs-divider>LISTA DE FIRMANTES</vs-divider>
                <vx-card class="mb-4">
                  <span class="bold">Solicitante</span> <br>
                  {{ project.client.user.person_type === 1 ? `${project.client.fiscal.first_name}
                  ${project.client.fiscal.second_name} ${project.client.fiscal.last_name_1}
                  ${project.client.fiscal.last_name_2}` : `${project.client.fiscal.name}` }} <br>
                  {{ project.client.fiscal.new_phone }}<br>
                  {{ project.client.user.email }}
                  <div v-if="getIdentityVerificationUrl() != null" class="mt-1">
                    <a :href="getIdentityVerificationUrl()" target="_blank" rel="noopener noreferrer">Consultar
                      verificación de identidad</a>
                  </div>
                </vx-card>
                <vx-card v-if="supplier != null" class="mb-4">
                  <span class="bold">Instalador</span> <br>
                  {{ project.supplier.tradename }} <br>
                  {{ supplier.phone }}<br>
                  {{ supplier.email }}
                  <div v-if="getSupplierIdentityVerificationUrl() != null" class="mt-1">
                    <a :href="getSupplierIdentityVerificationUrl()" target="_blank" rel="noopener noreferrer">Consultar
                      verificación de identidad</a>
                  </div>
                </vx-card>
                <vx-card v-for="guarantee in guarantees" class="mb-4">
                  <span class="bold">Obligado solidario</span> <br>
                  {{ guarantee.name }} <br>
                  {{ guarantee.phone }}<br>
                  {{ guarantee.email }}
                  <div v-if="guarantee.identity_verification_dashboard_url != null" class="mt-1">
                    <a :href="guarantee.identity_verification_dashboard_url" target="_blank"
                      rel="noopener noreferrer">Consultar verificación de identidad</a>
                  </div>
                </vx-card>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>

    <!-- DIÁLOGO PARA GENERAR LOS CONTRATOS-->
    <vs-popup :title="type == 1 ? 'Generar Contratos para ANTICIPO' : 'Generar Contratos para FINIQUITO'"
      :active.sync="showDialog" :style="!isFromProjects ? 'z-index: 90000 !important;' : ''">
      <vs-divider position="left">Método de firma</vs-divider>
      <div class="row">
        <div class="col-md-12">
          <div class="md-title col-sm-12 col-md-12">
            <ul class="centerx">
              <li>
                <vs-radio color="success" v-model.number="signing_type_wish_modal" vs-value="1">Firma
                  Autógrafa</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model.number="signing_type_wish_modal" vs-value="2">Firma Electrónica
                  Avanzada (e.firma)</vs-radio>
              </li>
              <!-- <li>
                    <vs-radio color="success" v-model.number="signing_type_wish_modal" vs-value="3">Firma Autógrafa Digital (FAD)</vs-radio>
                </li> -->
            </ul>
          </div>
        </div>
      </div>
      <vs-divider position="left" class="mb-0">Contratos</vs-divider>
      <md-card-content v-if="generation_contracts_group != null">
        <vs-checkbox v-for="group in generation_contracts_group.filter(item => { return item.group.type === type })"
          class="vs-custom" v-bind:key="group.group.id + '-' + group.version" v-model="generate_groups"
          :vs-value="group.group.id + '-' + group.version" :disabled="group.status === 'signed'">
          <span v-if="group.status === 'signed'" class="label label-status-1">{{ group.status }}</span>
          <span v-if="group.status === 'sent'" class="label label-status-10">{{ group.status }}</span>
          {{ group.group.name }} ver.{{ group.version }}
          <md-tooltip v-if="group.status === 'sent' && group.signing_type === 3">Al regenerar este grupo, la solicitud
            creada en FAD se cancelará</md-tooltip>
        </vs-checkbox>
        <div class="vx-row mt-4">
          <div class="vx-col w-1/4">
            <h6 class="bold">Documento(s)</h6>
          </div>
          <div class="vx-col w-full">
            <vs-table ref="table" stripe :data="contracts_list" noDataText="No hay datos disponibles">
              <template slot="thead">
                <vs-th class="bold" sort-key="group">Grupo</vs-th>
                <vs-th class="bold" sort-key="name">Nombre</vs-th>
                <vs-th class="bold" sort-key="version">Version</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr"
                  v-if="generate_groups.includes(tr.group.id + '-' + tr.version) && needsToShowDocument(tr.group.id, tr.name)">
                  <vs-td>{{ tr.group.name }}</vs-td>
                  <vs-td>{{ tr.name }}</vs-td>
                  <vs-td>{{ tr.version }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </md-card-content>
      <md-dialog-actions>
        <vs-button color="danger" type="line" @click="cerrarDialog()">CANCELAR</vs-button>
        <vs-button class="ml-2" color="success" @click="requestGenerateContracts()"
          :disabled="generate_groups.length == 0">CONFIRMAR</vs-button>
      </md-dialog-actions>
    </vs-popup>

    <!-- DIÁLOGO PARA ENVIAR LOS CONTRATOS A FIRMA -->
    <vs-popup :active.sync="showSentDialog" :style="!isFromProjects ? 'z-index: 90000 !important;' : ''">
      <md-dialog-title v-if="!isPromissory && contract_group != null">Enviar
        <strong><u>{{ contract_group.group.name }}</u></strong> a Firma</md-dialog-title>
      <md-dialog-title v-else="isPromissory && contract_group != null">Enviar <strong><u>Pagaré</u></strong> a
        Firma</md-dialog-title>
      <md-dialog-content v-if="contract_group != null">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 mt-2 mb-2">
              <label>Metodo de firma</label>
              <vs-select v-model.lazy="signing_type" class="w-full" name="eventSelected"
                placeholder="Seleccione una opción">
                <vs-select-item key="2" value="2" text="FIEL - Firma Electrónica Avanzada" />
                <vs-select-item key="1" value="1" text="Autógrafa" />
              </vs-select>
            </div>
          </div>
          <div class="row" v-if="signing_type == 3">
            <div class="col-md-12">
              <md-field>
                <label>Leyenda de Aceptación</label>
                <md-textarea v-model="acceptance_caption" md-autogrow></md-textarea>
              </md-field>
            </div>
          </div>
          <div class="row" v-if="signing_type == 3">
            <div class="col-md-4">
              <md-datepicker v-model="date_limit" md-immediately :md-disabled-dates="disabledDates">
                <label>Fecha Límite de Firma</label>
              </md-datepicker>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Días para firmar</label>
                <md-input v-model="days" type="number" min="0" style="text-align: center" disabled />
              </md-field>
            </div>
            <div class="col-md-4">
              <md-checkbox v-model="ivr" class="md-primary">¿Requiere Verificación de Identidad?</md-checkbox>
            </div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions v-if="contract_group != null">
        <vs-button color="dark" @click="cerrarSentDialog()">CANCELAR</vs-button>
        <vs-button color="primary" class="ml-1" @click="_sendContracts(contract_group.group.id)">ENVIAR</vs-button>
      </md-dialog-actions>
    </vs-popup>

    <!-- DIÁLOGO PARA DESCARGA DE LOS ARCHIVOS-->
    <vs-popup :active.sync="showDownloadDialog" class="extended-popup"
      :style="!isFromProjects ? 'z-index: 90000 !important;' : ''">
      <md-dialog-title v-if="contract_reference != null">Descargar archivos del grupo de documentos:
        <strong><u>{{ contract_reference.group.name }}</u></strong></md-dialog-title>
      <md-dialog-content v-if="contract_reference != null">
        <div class="container-fluid mb-base">
          <!-- versiones con componente -->
          <div class="vx-row">
            <document-upload-lite v-if="contract_reference.contract_not_signed_file !== null" :accepts="['pdf']"
              upload-type="not_signed" name="PDF Contrato sin firmar" :check-url="checkUrl" :view-url="viewUrl"
              :download-url="downloadUrl" :upload-url="uploadUrl" width="1/2" />

            <document-upload-lite v-if="contract_reference.contract_signed_xml_file !== null" :accepts="['xml']"
              upload-type="signed_xml" name="XML Contrato para FAD" :check-url="checkUrl" :view-url="viewUrl"
              :download-url="downloadUrl" :upload-url="uploadUrl" width="1/2" />

            <document-upload-lite
              v-if="contract_reference.contract_signed_file !== null || contract_reference.signing_type != 3"
              :accepts="['pdf', 'png', 'jpg', 'jpeg']" upload-type="signed" name="PDF Contrato firmado"
              :check-url="checkUrl" :view-url="viewUrl" :download-url="downloadUrl" :upload-url="uploadUrl"
              width="1/2" />

          </div>
          <div v-if="contract_reference.signing_type == 3" class="vx-row">
            <document-upload-lite v-if="contract_reference.contract_signed_fad_file != null" name="Archivo .fad"
              upload-type="file_fad" :check-url="checkUrl" :view-url="viewUrl" :download-url="downloadUrl"
              :upload-url="uploadUrl" width="1/2" :canUpload="false" />
            <document-upload-lite v-if="contract_reference.contract_signed_key_file != null" name="Archivo .key"
              upload-type="file_key" :check-url="checkUrl" :view-url="viewUrl" :download-url="downloadUrl"
              :upload-url="uploadUrl" width="1/2" :canUpload="false" />
          </div>
        </div>

        <div v-if="contract_pagare_reference != null">
          <vs-divider>PAGARÉ</vs-divider>
          <div class="container-fluid">
            <!-- versiones con componente -->
            <div class="vx-row">
              <document-upload-lite v-if="contract_pagare_reference.contract_not_signed_file !== null"
                :accepts="['pdf']" upload-type="not_signed" name="PDF Contrato sin firmar" :check-url="checkUrl"
                :view-url="viewUrl" :download-url="downloadUrl" :upload-url="uploadUrl"
                :promissary-id="contract_pagare_reference.id" width="1/2" />

              <document-upload-lite v-if="contract_pagare_reference.contract_signed_xml_file !== null"
                :accepts="['xml']" upload-type="signed_xml" name="XML Contrato para FAD" :check-url="checkUrl"
                :view-url="viewUrl" :download-url="downloadUrl" :upload-url="uploadUrl"
                :promissary-id="contract_pagare_reference.id" width="1/2" />

              <document-upload-lite
                v-if="contract_pagare_reference.contract_signed_file !== null || contract_reference.signing_type != 3"
                :accepts="['pdf', 'png', 'jpg', 'jpeg']" upload-type="signed" name="PDF Contrato firmado"
                :check-url="checkUrl" :view-url="viewUrl" :download-url="downloadUrl" :upload-url="uploadUrl"
                :promissary-id="contract_pagare_reference.id" width="1/2" />
            </div>

            <!-- keys -->
            <div v-if="contract_pagare_reference.signing_type == 3" class="vx-row">
              <document-upload-lite v-if="contract_pagare_reference.contract_signed_fad_file !== null"
                name="Archivo .fad" upload-type="file_fad" :check-url="checkUrl" :view-url="viewUrl"
                :download-url="downloadUrl" :upload-url="uploadUrl" :promissary-id="contract_pagare_reference.id"
                width="1/2" :canUpload="false" />
              <document-upload-lite v-if="contract_pagare_reference.contract_signed_key_file !== null"
                name="Archivo .key" upload-type="file_key" :check-url="checkUrl" :view-url="viewUrl"
                :download-url="downloadUrl" :upload-url="uploadUrl" :promissary-id="contract_pagare_reference.id"
                width="1/2" :canUpload="false" />
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <!-- fin versiones con componente -->
          <vs-divider>IDENTIFICACIÓN DE SOLICITANTE</vs-divider>
          <div class="vx-row">
            <document-upload-lite v-if="id_front != ''" name="Identificación Frente" :check-url="id_front.checkUrl"
              :view-url="id_front.url_file" download-url="/" upload-url="/" width="1/2" :canUpload="false" />
            <document-upload-lite v-if="id_back != ''" name="Identificación Posterior" :check-url="id_back.checkUrl"
              :view-url="id_back.url_file" download-url="/" upload-url="/" width="1/2" :canUpload="false" />
          </div>
        </div>

      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="cerrarDownloadDialog()">CERRAR</md-button>
      </md-dialog-actions>
    </vs-popup>

    <!-- DIÁLOGO CON LA INFO DE FAD-->
    <vs-popup :active.sync="showFADDialog" :style="!isFromProjects ? 'z-index: 90000 !important;' : ''">
      <md-dialog-title v-if="contract_group != null">Información FAD del Grupo de Contratos:
        <strong><u>{{ contract_group.group.name }}</u></strong></md-dialog-title>
      <md-dialog-content v-if="contract_group != null">
        <md-list v-if="contract_group.fad != null">
          <md-list-item><span class="md-list-item-text">ID Solicitud:
              <strong>{{ contract_group.fad.requisitionId }}</strong></span></md-list-item>
          <md-list-item><span class="md-list-item-text">Llave:
              <strong>{{ contract_group.fad.key }}</strong></span></md-list-item>
          <md-list-item><span class="md-list-item-text">Vector:
              <strong>{{ contract_group.fad.vector }}</strong></span></md-list-item>
          <md-list-item md-expand md-expanded v-if="missingSigns.length > 0 && loadingSigns == false">
            <span class="md-list-item-text">Firmas faltantes:</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" v-for="signer in missingSigns" v-bind:key="signer"><strong>{{ signer
                  }}</strong></md-list-item>
            </md-list>
          </md-list-item>
          <md-list-item v-else-if="loadingSigns" style="margin-left: 40%">
            <md-progress-spinner :md-diameter="40" :md-stroke="5" md-mode="indeterminate" />
          </md-list-item>
        </md-list>
        <div v-if="contract_group.group.id == 1 && contract_pagare_reference != null">
          <vs-divider>PAGARÉ</vs-divider>
          <md-list v-if="contract_pagare_reference.fadLink != null">
            <md-list-item><span class="md-list-item-text">ID Solicitud:
                <strong>{{ contract_pagare_reference.fadLink.requisitionId }}</strong></span></md-list-item>
            <md-list-item><span class="md-list-item-text">Llave:
                <strong>{{ contract_pagare_reference.fadLink.key }}</strong></span></md-list-item>
            <md-list-item><span class="md-list-item-text">Vector:
                <strong>{{ contract_pagare_reference.fadLink.vector }}</strong></span></md-list-item>
          </md-list>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="cerrarFADDialog()">CANCELAR</md-button>
      </md-dialog-actions>
    </vs-popup>

    <vs-popup v-if="currentContractInfo != null" :active.sync="popUpActive" title="Información de firmas"
      :style="!isFromProjects ? 'z-index: 90000 !important;' : ''">
      <vx-card v-if="currentContractInfo.signing_type == 3" class="mb-5" title="Urls" title-color="primary">
        <span v-for="fadLink in buildFADLinks(currentContractInfo, currentContractInfo.contract_group_id)">
          <strong>{{ fadLink.type }}:</strong> <a style="overflow-wrap: break-word;" :href="fadLink.ticket"
            target="_blank">
            {{ fadLink.ticket }} </a> <br>
        </span>
      </vx-card>
      <vx-card v-else-if="currentContractInfo.signing_type == 2" class="mb-5" title="Urls" title-color="primary">
        <vx-card class="mb-base" v-for="(signer, index) in buildMiFielLinks(currentContractInfo.mifiel_object)">
          <ul>
            <li>
              <strong>Nombre del firmante: </strong> {{ signer.name }}
            </li>
            <li>
              <strong>Email: </strong> {{ signer.email }}
            </li>
            <li>
              <strong>RFC: </strong> {{ signer.tax_id }}
            </li>
            <li>
              <strong>Estado de firma: </strong> {{ signer.status }}
            </li>
            <li>
              <strong>Método de firma: </strong> {{ signer.sign_method || "N/A" }}
            </li>
            <li>
              <strong>¿Está firmado? </strong> {{ signer.signed ? 'Sí' : 'No' }}
            </li>
            <li>
              <strong>Ticket: </strong> {{ signer.widget_id }}
            </li>
            <li>
              <strong>Url de firma: </strong> <a
                :href="`https://app.redgirasol.com/firma-de-contratos/?reqId=${currentContractInfo.id}&ticket=${signer.widget_id}`"
                target="_blank">https://app.redgirasol.com/firma-de-contratos/?reqId={{ currentContractInfo.id
                }}&ticket={{
                  signer.widget_id }}</a>
            </li>
          </ul>
        </vx-card>
      </vx-card>
    </vs-popup>

  </div>
</template>

<script lang="js">

import { humanDateFilter } from "../../../../components/admin/filters/humanDateFilter";
import { mapActions, mapState } from "vuex";
import { is } from "../../functions/userRoleBehavior";
import { ContractProvider } from "../../../../bl/enums/ContractProvider";
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import Datepicker from 'vue-datepicker'
import dateHelper from "@mixins/dateHelper";
import projectStatusesHelper from "@mixins/projectStatusesHelper";

const GROUP_ONE_ID = 1;
const GROUP_TWO_ID = 2;
const ECO_PRODUCTS = [1,6];

export default {
  name: 'tab-contracts-2',
  components: {
    DocumentUploadLite,
    Datepicker
  },
  mixins: [dateHelper, projectStatusesHelper],
  props: {
    project: { type: [Object], required: true }
    , isFromProjects: { type: Boolean, default: true }
  },
  filters: {
    'humanDate': humanDateFilter
  },
  data() {
    return {
      generate_groups: [],
      popUpActive: false,
      currentContractInfo: null,


      contracts_table: [],
      contracts_list: [],
      contract_groups: null,
      contracts: [],
      old_first_payment_date: null,
      contract_id: null,
      type: null,
      showDialog: false,
      showSentDialog: false,
      showDownloadDialog: false,
      showed: [],

      contract_group: null,
      signing_type: "2",
      acceptance_caption: '',
      date_limit: null,
      days: null,
      ivr: false,

      contract_reference: null,
      contract_pagare_reference: null,

      showFADDialog: false,
      missingSigns: [],
      loadingSigns: false,

      today: new Date(),
      disabledDates: date => {
        return date <= this.today ||
          (date.getFullYear() === this.today.getFullYear() &&
            date.getMonth() === this.today.getMonth() &&
            date.getDate() === this.today.getDate());
      },

      generationMessageConfirmation: '',
      generation_contracts_group: [],

      supplier: null,
      guarantees: [],

      id_version: '',

      signing_type_wish_modal: 2
      , GROUP_ONE_ID: GROUP_ONE_ID
      , GROUP_TWO_ID: GROUP_TWO_ID
      , currentGroup: null
      , id_back: ''
      , id_front: ''
      , isPromissory: false
      , relatedProjects: []
      , collections: {
        financial_products: []
      },
    }
  },
  computed: {
    // ...mapState('projects', ['project']),
    ...mapState('auth', ['user']),
    is_admin() {
      return is('admin', this.user.user_roles)
    },
    checkUrl() {
      if (this.contract_reference) {
        return `project/${this.project.id}/contracts/info/${this.contract_reference.contract_group_id}`;
      }
      return null;
    },
    viewUrl() {
      if (this.contract_reference) {
        return `project/${this.project.id}/contracts/view/${this.contract_reference.contract_group_id}`;
      }
      return null;
    },
    downloadUrl() {
      if (this.contract_reference) {
        return `project/${this.project.id}/contracts/download/${this.contract_reference.contract_group_id}`;
      }
      return null;
    },
    uploadUrl() {
      if (this.contract_reference) {
        return `project/${this.project.id}/contracts/upload/${this.contract_reference.contract_group_id}`;
      }
      return null;
    },
    hasContractsGenerated() { // VALIDACIÓN PARA GENERAR SEGUNDOS CONTRATOS
      if(this.isNewLoanVersion) {
        return false;
      }
      if (this.contract_groups !== null && this.contract_groups.length > 0) {
        let GroupOne = this.contract_groups.some(item => item.group.id === this.GROUP_ONE_ID);
        let GroupTwo = this.contract_groups.some(item => item.group.id === this.GROUP_TWO_ID);
        if (this.project.finance.loan_type == 1) {
          return (GroupOne && GroupTwo);
        } else {
          return GroupOne;
        }
      } else {
        return false;
      }
    },
    // allDocumentsVerified() {
    //   return this.project.all_documents_verified_timestamp != null;
    // }
    isNewLoanVersion() {
      return this.collections.financial_products.some(item => {
        return item.id === this.project.finance.financial_product_id
      });
    },
    isEcoProduct() {
      return ECO_PRODUCTS.includes(this.project.finance.loan_type);
    },
  },
  mounted() {
    this.signing_type = this.project.signing_type;
    this.old_first_payment_date = Object.assign({}, this.project.finance.first_payment_date)
    axios.get('/api/catalogs/contracts/projects/active').then(response => {
      this.contracts_table = response.data.data;
      var flags = [], cg = [], l = this.project.contracts.length, i;
      for (i = 0; i < l; i++) {
        if (this.project.contracts[i].group !== null) {
          if (flags[this.project.contracts[i].group.id]) continue;
          flags[this.project.contracts[i].group.id] = true;
          cg.push({
            group: this.project.contracts[i].group,
            status: this.project.contracts[i].status,
            fad: this.project.contracts[i].fad_requisition_json,
            ivr: this.project.contracts[i].identity_validation_request,
            signing_type: this.project.contracts[i].signing_type,
          });
          this.showed.push(this.project.contracts[i].group.id);
        } else { continue; }
      }

      this.contract_groups = cg;
      this.contract_groups.sort((a, b) => (a.group.id > b.group.id) ? 1 : ((b.group.id > a.group.id) ? -1 : 0));

      var gflags = [], gcg = [], gl = this.contracts_table.length, gi;
      for (gi = 0; gi < gl; gi++) {
        let contractVersion = `${this.contracts_table[gi].group.id}-${this.contracts_table[gi].version}`;
        if (gflags[contractVersion]) continue;
        gflags[contractVersion] = true;
        let cg = this.contract_groups.find(cg => { return cg.group.id === this.contracts_table[gi].group.id });
        let status = cg != null ? cg.status : null
        let signing_type = cg != null ? cg.signing_type : null
        gcg.push({
          group: this.contracts_table[gi].group,
          version: this.contracts_table[gi].version,
          status: status,
          fad: this.contracts_table[gi].fad_requisition_json,
          ivr: this.contracts_table[gi].identity_validation_request,
          signing_type: signing_type,
        });
      }

      this.generation_contracts_group = gcg;
      this.generation_contracts_group.sort((a, b) => (a.group.id > b.group.id) ? 1 : ((b.group.id > a.group.id) ? -1 : 0));
    });

    axios.get('/api/supplier/detail/' + this.project.supplier_id).then(response => {
      this.supplier = response.data;
    })

    axios.get('/api/project/' + this.project.id + '/guarantees').then(response => {
      this.guarantees = response.data.data;
    });

    this.getRelatedProjects();
    this.getCollections();
  },
  methods: {
    ...mapActions('projects', ['generateContracts', 'sendContracts', 'resendContracts', 'cancelContracts']),
    changeFirstPaymentDateHandler() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Cambiar fecha de primer pago',
        text: '¿Estás seguro de cambiar la fecha de primer pago?',
        acceptText: 'Aceptar',
        accept: this.changeFirstPaymentDate,
        cancelText: 'Cancelar',
        cancel: false
      });
    },
    async changeFirstPaymentDate() {
      await axios.put(`api/loan/${this.project.id}/amortization/first-payment-date`, {
        finance_product_id: this.project.finance.financial_product_id,
      })
    },
    buildMiFielLinks(miFielObject) {
      let links = [];
      if (miFielObject != null) {
        const data = JSON.parse(miFielObject);
        links = data.signers;
      }
      return links;
    },
    buildFADLinks(contract, contractGroup) {
      if (contract.fad_requisition != null) {
        const url = "https://mobile.firmaautografa.com/main?ticket=";
        let requisition = JSON.parse(contract.fad_requisition);
        let index = 0;
        let allTickets = Object.values(requisition.allTickets);
        let fadLink = {};
        let allLinks = [];
        fadLink.vector = requisition.vector;
        fadLink.key = requisition.key;

        allTickets.forEach(ticket => {
          if (index == 0) {
            fadLink.type = "Firma Solicitante";
          } else {
            if (contractGroup == 1) {
              fadLink.type = "Firma Obligado Solidario";
            } else if (contractGroup == 2 || contractGroup == 4) {
              fadLink.type = "Firma Proveedor";
            }
            fadLink.type = "N/A";
          }
          fadLink.ticket = url + ticket;
          index++;
          allLinks.push(fadLink);
        });

        return allLinks;
      }
    },
    showFADLinks(contracts) {
      this.popUpActive = true;
      this.currentContractInfo = contracts
    },
    requestUpdateContractData() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Fecha de primer pago.',
        text: `¿Estás seguro de actualizar la fecha de primer pago a ${this.project.finance.first_payment_date}?`,
        acceptText: 'Aceptar',
        accept: this.__updateContractData,
        cancelText: 'Cancelar',
        cancel: false
      });
    },
    async __updateContractData() {
      this.showLoading(true);
      try {
        await axios.put(`/api/project/${this.project.id}`, { signing_type: this.project.signing_type })
        await axios.put(`/api/loan/${this.project.id}/amortization/first-payment-date`, {
          first_payment_date: this.project.finance.first_payment_date,
          finance_product_id: this.project.finance.financial_product_id
        })
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (ex) {
        this.showLoading(false);
        swal("Ups!", "Hubo un error al guardar la información", "error")
      }
      this.showLoading(false);
    },
    async _sendContracts(id) {
      let messageConfirmation = "¿Esta seguro de enviar contratos a firma por email de manera autógrafa?";
      if (this.signing_type == ContractProvider.FAD) {
        messageConfirmation = "¿Esta seguro de enviar contratos a firma por FAD?";
      } else if (this.signing_type == ContractProvider.MIFIEL) {
        messageConfirmation = "¿Esta seguro de enviar contratos a firma por e.firma?";
      }
      this.cerrarSentDialog(2);
      if (confirm(messageConfirmation)) {
        this.show = true;
        try {
          await this.sendContracts({
            pid: this.project.id,
            id: id,
            signing_type: this.signing_type,
            acceptance_caption: this.acceptance_caption,
            date_limit: this.date_limit,
            days: this.days,
            ivr: this.ivr,
            isPromissory: this.isPromissory
          })
          swal("Ok!", "Los contratos se han enviado correctamente!", "success");
          location.reload()
        } catch (err) {
          console.error(err)
          swal("Ups!", err.response.data.message, "error")
        } finally {
          this.show = false;
        }
      }
    },
    async _resendContracts(group) {
      let messageConfirmation = "¿Esta seguro de reenviar el correo para la firma de éstos contratos?";
      if (confirm(messageConfirmation)) {
        this.show = true;
        try {
          await this.resendContracts({
            pid: this.project.id,
            id: group.group.id,
            signing_type: group.signing_type,
          })
          swal("Ok!", "Los contratos se han reenviado correctamente!", "success");
        } catch (err) {
          console.error(err)
          swal("Ups!", err.response.data.message, "error")
        } finally {
          this.show = false;
        }
      }
    },
    requestGenerateContracts() {
      this.generationMessageConfirmation = "¿Esta seguro de generar los siguientes contratos?";
      this.generate_groups.forEach(item => {
        this.id_version = item.split("-");
        let c = this.generation_contracts_group.find(cg => { return cg.group.id === parseInt(this.id_version[0]) });
        this.generationMessageConfirmation += '\n\n-> ' + c.group.name;
        if (c.status === 'sent') this.generationMessageConfirmation += ' (Al regenerar este grupo, la solicitud creada quedará inservible, se creará una nueva cuando se envíen a firma nuevamente por este medio.)'
      })
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Generar contratos',
        text: `${this.generationMessageConfirmation}`,
        acceptText: 'Aceptar',
        accept: this._generate_contracts,
        cancelText: 'Cancelar',
        cancel: false
      });
    },
    async _generate_contracts() {
      this.showDialog = false;
      this.showLoading(true);
      try {
        await this.generateContracts({
          pid: this.project.id,
          ids: this.generate_groups
          , signing_type_wish: this.signing_type_wish_modal
        });
        swal("Ok!", "Los contratos se están generando, regresa más tarde para consultarlos.", "success");
        this.showLoading(false);
        // location.reload();
      } catch (e) {
        this.showLoading(false);
        swal("Ups!", e.response.data, "error")
      }
      this.generationMessageConfirmation = '';
    },
    verDialog(id) {
      this.type = id;
      this.contracts_list = this.contracts_table.filter(item => {
        return item.group.type === id
      })
      this.showDialog = true;
    },
    cerrarDialog() {
      this.showDialog = false;
      this.type = null;
      this.generate_groups = [];
      this.signing_type_wish_modal = 2;
    },
    expandir(id) {
      const index = this.showed.indexOf(id);
      if (index > -1) {
        this.showed.splice(index, 1)
      } else {
        this.showed.push(id)
      }
    },
    verSentDialog(group, isPromissory = false) {
      this.isPromissory = isPromissory;
      this.showSentDialog = true;
      this.contract_group = group;
      this.days = group.group.signing_due_days;
      this.ivr = group.group.identity_validation_request == 1 ? true : false;
      this.acceptance_caption = group.group.acceptance_caption;

      var fecha = new Date();
      fecha.setDate(fecha.getDate() + parseInt(this.days));
      this.date_limit = this.getDate(fecha);
    },
    cerrarSentDialog(id) {
      this.showSentDialog = false;
      if (id != 2) {
        this.contract_group = null;
        this.days = 0;
        this.ivr = false;
        this.signing_type = this.project.signing_type;
      }
    },
    getDate(fecha) {
      if (fecha.getMonth() < 9 && fecha.getDate() < 10) return fecha.getFullYear() + '-0' + (fecha.getMonth() + 1) + '-0' + fecha.getDate();
      if (fecha.getMonth() < 9) return fecha.getFullYear() + '-0' + (fecha.getMonth() + 1) + '-' + fecha.getDate();
      if (fecha.getDate() < 10) return fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-0' + fecha.getDate();
      return fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getDate()
    },
    async cancelarGrupo(group) {
      if (confirm("¿Desea cancelar los contratos del grupo: " + group.group.name + "?")) {
        try {
          await this.cancelContracts({
            pid: this.project.id,
            gid: group.group.id
          });
          swal("Ok!", "Los contratos se han cancelado correctamente!", "success");
          location.reload();
        } catch (e) {
          console.error(e);
          swal("Ups!", e.response.data.message, "error")
        }
      }
    },
    async verDownloadDialog(group, isDownload = true) {
      this.showDownloadDialog = isDownload;
      if (isDownload) {
        await this.calculateIdURLs();
      }
      let pc = this.project.contracts.filter(item => { return item.contract_group_id === group.group.id })
      this.contract_reference = pc[0];

      for (let index = 0; index < pc.length; index++) {
        const element = pc[index];
        if (element.type.name == "Pagaré") {
          this.contract_pagare_reference = element;
          if (this.contract_pagare_reference.fad_requisition) {
            this.contract_pagare_reference.fadLink = JSON.parse(this.contract_pagare_reference.fad_requisition);
          } else {
            this.contract_pagare_reference.fadLink = null;
          }
          break;
        }
      }
    },
    cerrarDownloadDialog() {
      this.showDownloadDialog = false;
      this.contract_reference = null;
    },
    verFADDialog(group) {
      this.showFADDialog = true;
      this.contract_group = group;
      this.loadingSigns = true;
      axios.post('/api/fad/check/signatures', {
        'ivr': group.ivr,
        'fid': group.fad.requisitionId,
      }).then(response => {
        this.missingSigns = response.data.data
        this.loadingSigns = false;
      });
      this.verDownloadDialog(group, false);
    },
    manualSigned(group) {
      if (confirm("¿Está seguro de marcar el Grupo " + group.group.name + " como firmado? \n\nRecuerde que después de hacer esto se tiene que subir el contrato firmado escaneado")) {
        axios.get(`/api/project/${this.project.id}/contracts/manual_sign/${group.group.id}`).then(response => {
          swal("Ok!", "Los contratos se han marcado como firmados!", "success");
          location.reload();
        }).catch(error => {
          console.error(error);
          swal("Ups!", error.response.data.message, "error")
        });
      }
    },
    cerrarFADDialog() {
      this.showFADDialog = false;
      this.missingSigns = [];
      this.contract_group = null;
    },
    async requestVerification(group) {
      this.currentGroup = group;
      let ok = group.status === 'signed';
      if (!ok) {
        return;
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Solicitar verificación de contratos',
        text: `¿Estás seguro que deseas verificar los contratos del grupo ${group.group.name}?`,
        acceptText: "Enviar solicitud",
        cancelText: 'Cancelar',
        accept: this.doRequestVerification
      });
    },
    async doRequestVerification() {
      this.showLoading(true);
      try {
        await axios.get(`/api/project/${this.project.id}/contracts/verified/${this.currentGroup.group.id}`);
        this.saveSuccessNotif();
        location.reload();
      } catch (error) {
        const responseData = error.response && error.response.data;
        const generalErrors = responseData && responseData.errors && responseData.errors.general;
        const message = Array.isArray(generalErrors) ? generalErrors[0] : responseData && responseData.message;
        swal("Ups!", message || "Hubo un error al verificar los contratos.", "error");
      }
      this.showLoading(false);
    },
    setDeliveryService(type) {
      let name = "";
      switch (type) {
        case 1:
          name = "Mensajería propia"
          break;
        case 2:
          name = "Correos de México"
          break;
        case 3:
          name = "DHL"
          break;
        case 4:
          name = "Estafeta"
          break;
        case 5:
          name = "FedEx"
          break;
        case 6:
          name = "PaqueteExpress"
          break;
        case 7:
          name = "RedPack"
          break;
        case 8:
          name = "Sendex Paquetería"
          break;
        case 9:
          name = "UPS"
          break;
        case 10:
          name = "Otro servicio"
          break;
        default: name = "--"
      }
      return name;
    },
    async calculateIdURLs() {
      this.id_back = "";
      this.id_front = "";
      const documentIds = [14, 15, 21, 22];
      if (this.project.client.user.personal_profile_id != null) {
        this.id_front = await this.getFile(this.project.client.user.id, documentIds[0]);
        this.id_back = await this.getFile(this.project.client.user.id, documentIds[1]);
      } else {
        this.id_front = await this.getFile(this.project.client.user.id, documentIds[2]);
        this.id_back = await this.getFile(this.project.client.user.id, documentIds[3]);
      }
    },
    async getFile(user_id, document_id) {
      try {
        let url_data = `/storagev3/documents/files/${document_id}/user/${user_id}`
        const response = await axios.get(url_data);
        if (response.data.length > 0) {
          const file = response.data[0];
          return {
            url_file: `view_document_file/${file.id}/user/${user_id}`,
            filename: file.storage_file,
            checkUrl: `files/getDocumentFile/${file.id}`
          }
        } else {
          return '';
        }

      } catch (e) {
        return '';
      }
    },
    getIdentityVerificationUrl() {
      if (this.project.client.user.person_type == 1) { // PF
        return this.project.client.fiscal.identity_verification_dashboard_url;
      } else {
        return this.project.client.user.business.personal.identity_verification_dashboard_url
      }
    },
    getSupplierIdentityVerificationUrl() {
      if (this.project.supplier.user.person_type == 1) { // PF
        return this.project.supplier.user.personal.identity_verification_dashboard_url;
      } else {
        return this.project.supplier.user.business.personal.identity_verification_dashboard_url
      }
    },
    async loanFormalization() {
      try {
        this.showLoading(true, "Formalizando crédito");
        const res = await axios.post(`/api/loan-onboarding/post/${this.project.id}/loan-formalization`);
        this.saveSuccessNotif();
        this.showLoading(false);
      } catch (error) {
        console.error(error);
        this.failedOperationNotif;
      }
    },
    async loanDisposition() {
      try {
        this.showLoading(true, "Disposición de crédito");
        const res = await axios.post(`/api/loan-onboarding/post/${this.project.id}/loan-dispose`);
        this.saveSuccessNotif();
        this.showLoading(false);
      } catch (error) {
        console.error(error);
        this.failedOperationNotif;
      }
    },
    isContractGroupVerified(group) {
      const currentGroup = this.contract_groups.find(cg => cg.group.id === group);
      if (currentGroup != null) {
        return currentGroup.status == "verified";
      }

      return false;
    },
    async getRelatedProjects() {
      const { data } = await axios.get(`/api/v2/projects/${this.project.id}/getProjectsRelated`);
      this.relatedProjects = data;
    },
    getContractToRender(contractGroupId) {
      return this.project.contracts.filter(item => { return item.contract_group_id === contractGroupId })[0];
    },
    async getCollections(){
      try {
        let collectionsObjects = ['financialProducts'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        let colls = res.data;
        this.collections.financial_products = colls.financialProducts;

      } catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    needsToShowDocument(group, document) {
      if(!this.isNewLoanVersion) return true;
      // Sí es eco no necesita el anexo 5 en el grupo 1
      if(group == 1 && this.isEcoProduct) {
        return document != "Anexo 5: Prenda en Garantía";
      }

      if(group == 2 && this.isEcoProduct) {
        return document != "Compraventa";
      }

      return true;
    }
  },
  watch: {
    // days:function (){
    //   var fecha = new Date();
    //   fecha.setDate(fecha.getDate() + parseInt(this.days));
    //   this.date_limit = this.getDate(fecha);
    // },
    date_limit: function () {
      var fecha = new Date();
      var fecha2 = new Date(this.date_limit);
      var diffTime = fecha2.getTime() - fecha.getTime();
      this.days = Math.ceil(diffTime / (1000 * 3600 * 24));
    }
  }
}


</script>

<style scoped lang="scss">
.con-vs-dialog {
  z-index: 100000 !important;
}

.not-generated {
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.contract-status {
  width: 1rem;
  height: 1rem;
  border-radius: 15px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 7px;
}
</style>
